import React from "react";
import { Input } from "antd";
import debounce from "lodash/debounce";

const MenuConfigurationSearch = ({
  filterMenuItems,
  menuDataSource,
  setSearchedTable,
  setSearchedValue,
  setSearcheFilterItems,
  tabSelected,
  categoriesDataSource,
  setFilterTable,
}) => {
  const onSearchMenuItems = (
    value,
    filterMenuItems,
    dataSource,
    setSearchedTable,
    setSearchedValue,
    setSearcheFilterItems
  ) => {
    if (filterMenuItems === null) {
      const filteredItemsWithSearch = dataSource?.filter((item) =>
        Object.keys(item).some((itemProperty) => {
          if (value?.target?.value.slice(-1) === "0") {
            // Remove the last character if is 0 because we add it when we show item price
            value.target.value = value.target.value.slice(0, -1);
          }
          return String(item[itemProperty])
            .toLowerCase()
            .includes(value?.target?.value?.toLowerCase());
        })
      );
      setSearchedTable(filteredItemsWithSearch);
      setSearchedValue(value.target.value);
    } else {
      const filteredItemsWithSearch = filterMenuItems?.filter((item) =>
        Object.keys(item).some((itemProperty) => {
          return String(item[itemProperty])
            .toLowerCase()
            .includes(value?.target?.value?.toLowerCase());
        })
      );

      setSearcheFilterItems(filteredItemsWithSearch);
    }
  };

  const onSearchCategories = (value, dataSource, setFilterTable) => {
    const r = dataSource.filter((o) =>
      Object.keys(o).some((k) =>
        String(o[k]).toLowerCase().includes(value.target.value.toLowerCase())
      )
    );
    setFilterTable(r);
  };

  const debouncedSearchMenuItems = debounce(onSearchMenuItems, 500);

  return (
    <>
      <Input
        className="menu-configuration-search-input"
        placeholder="Търсене"
        onChange={(value) => {
          if (tabSelected === "menu") {
            debouncedSearchMenuItems(
              value,
              filterMenuItems,
              menuDataSource,
              setSearchedTable,
              setSearchedValue,
              setSearcheFilterItems
            );
          } else if (tabSelected === "categories") {
            onSearchCategories(value, categoriesDataSource, setFilterTable);
          }
        }}
      />
    </>
  );
};

export default MenuConfigurationSearch;
